import 'twin.macro';
import React from 'react';
import Button from '@teetsh/app/src/components/Buttons/Button';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';
import { ArrowPathIcon as Refresh } from '@heroicons/react/20/solid';
import { useTranslation } from 'react-i18next';

interface Props {
  link?: string;
  textLink?: string;
  error: Error;
  subject?: string;
}

export default function ErrorFallback({
  error,
  link,
  textLink,
  subject,
}: Props) {
  const { t } = useTranslation(['common']);
  return (
    <div tw="grid place-items-center pt-8">
      <div role="alert" tw="pt-20">
        <div tw="text-8xl font-bold mb-4">{t('common:errorPage.oups')}</div>
        <div tw="text-4xl">
          {subject
            ? t('common:errorPage.thereWasAProblemWith', {
                label: subject,
              })
            : t('common:errorPage.thereWasAProblemWithSomething')}
        </div>
        <div tw="text-xl">{t('common:errorPage.weHaveBeenNotified')}</div>
        <div tw="overflow-x-auto">
          <pre tw="py-3 whitespace-pre">{error.message}</pre>
        </div>
        <div tw="py-3 mb-3">
          <div tw="text-xl mb-3">{t('common:errorPage.suggestions')}</div>
          <div tw="flex items-center">
            <Button
              large
              outlined
              intent="primary"
              onClick={() => window.location.reload()}
              icon={Refresh}
            >
              {t('common:buttons.reloadPage')}
            </Button>
            {link && (
              <ButtonLink tw="ml-3" large outlined intent="primary" to={link}>
                {textLink}
              </ButtonLink>
            )}
          </div>
        </div>
        <div tw="py-2 text-lg">
          {t('common:errorPage.contactUsIfPersisting')}
          <br />
          <a href="mailto:hello@teetsh.com">hello@teetsh.com</a> <br />
          {t('common:errorPage.orUsingTheChat')}
        </div>
      </div>
    </div>
  );
}
